export const getInitialState = (): any => ({
  modelTrainData: {}
});
